import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { OrgServiceMemberDto, orgMemberFromDto } from '@nx-frontend/shared/types';

interface GetOrgMembersWithOwnerParams {
  host: string;
  orgId: string;
  userId: number;
}

export async function getOrgMembersWithOwner(params: GetOrgMembersWithOwnerParams) {
  const { host, orgId, userId } = params;
  const { data: membersRes } = await axiosClient.get<OrgServiceMemberDto[]>(
    `${assertServiceHost(host)}/v1/orgs/${orgId}/membersWithOwner`,
    {
      userId,
    }
  );
  return membersRes.map((item) => orgMemberFromDto(item));
}
